import {withTranslation} from '@wix/yoshi-flow-editor'
import {resolveButtonTextTranslation, resolveStatusTextTranslation} from '../../selectors/member-rsvp'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {ChangeRsvp as Presentation} from './change-rsvp'
import {ChangeRsvpRuntimeProps} from './interfaces'

const mapRuntimeToProps = ({state, actions: {changeMemberRsvp}}: DetailsPageAppProps): ChangeRsvpRuntimeProps => ({
  rsvpStatusMessageTranslation: resolveStatusTextTranslation(state),
  rsvpStatusButtonTextTranslation: resolveButtonTextTranslation(state),
  changeMemberRsvp,
})

export const ChangeRsvp = connect<{}, ChangeRsvpRuntimeProps>(mapRuntimeToProps)(withTranslation()(Presentation))
